import { createContext, useContext, useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import qs from "qs";
import { useLocation } from "react-router";

export const CommitmentContext = createContext();

export const CommitmentProvider = ({ children }) => {
  // Getting location object from useLocation (react-router)
  const location = useLocation();

  // State for filters
  const params = qs.parse(location.search, { ignoreQueryPrefix: true });
  const [filters, setFilters] = useState({
    dealName: params.dealName || "",
    departmentName: params.departmentName || "",
    departmentOrdCode: params.departmentOrdCode
      ? params.departmentName.split("(").pop().split(")")[0].trim()
      : "",
    status: params.status || "",
    project: params.project || "",
    task: params.task || "",
    award: params.award || "",
  });

  // State for Sort
  const [sort, setSort] = useState({
    column: "name",
    orderBy: "asc",
  });

  // State for pagination
  const [pagination, setPagination] = useState({
    page: 0,
    rowsPerPage: 25,
  });

  // State for keeping commitment id for opened component drawer
  const [openCommitmentId, setOpenCommitmentId] = useState(0);

  // For commitment documents

  // State for commitment document Sort
  const [docSort, setDocSort] = useState({
    column: "name",
    orderBy: "asc",
  });

  // State for commitment document pagination
  const [docPagination, setDocPagination] = useState({
    page: 0,
    rowsPerPage: 10,
  });

  // State for commitment document pagination
  const [financialHistoryPagination, setFinancialHistoryPagination] = useState({
    page: 0,
    rowsPerPage: 10,
    componentId: "",
  });

  const [
    financialHistorySelectedFiscalYear,
    setFinancialHistorySelectedFiscalYear,
  ] = useState(0);

  useEffect(() => {
    const pathname = location.pathname.split("/")[1];
    // checks if the pathname is not "/" and "/commitments" then clear filters
    if (pathname !== "" && pathname !== "commitments") {
      setFilters({
        dealName: params.dealName || "",
        departmentName: params.departmentName || "",
        departmentOrdCode: params.departmentOrdCode || "",
        status: params.status || "",
        project: params.project || "",
        task: params.task || "",
        award: params.award || "",
      });
      setSort({
        column: "name",
        orderBy: "asc",
      });
      setPagination({
        page: 0,
        rowsPerPage: 25,
      });
      // For documents

      setDocSort({
        column: "name",
        orderBy: "asc",
      });
      setDocPagination({
        page: 1,
        rowsPerPage: 10,
      });
      setFinancialHistoryPagination({
        page: 0,
        rowsPerPage: 10,
        componentId: "",
      });
    }
  }, [
    location,
    params.dealName,
    params.departmentName,
    params.departmentOrdCode,
    params.status,
    params.project,
    params.task,
    params.award,
  ]);

  const contextValue = useMemo(
    () => ({
      filters,
      setFilters,
      sort,
      setSort,
      pagination,
      setPagination,
      openCommitmentId,
      setOpenCommitmentId,
      docPagination,
      setDocPagination,
      docSort,
      setDocSort,
      financialHistoryPagination,
      setFinancialHistoryPagination,
      financialHistorySelectedFiscalYear,
      setFinancialHistorySelectedFiscalYear,
    }),
    [
      filters,
      sort,
      pagination,
      openCommitmentId,
      docPagination,
      docSort,
      financialHistoryPagination,
      financialHistorySelectedFiscalYear,
    ],
  );

  return (
    <CommitmentContext.Provider value={contextValue}>
      {children}
    </CommitmentContext.Provider>
  );
};

CommitmentProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useCommitmentContext = () => {
  return useContext(CommitmentContext);
};
